
<div class="content-dash">
    <div class="title-top"><h1>{{ 'direcciones.title' | translate }}</h1><button><img src="/assets/icons/plus.svg" alt="">{{ 'direcciones.addButton' | translate }}</button></div>
    
    <app-address></app-address>

</div>